import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
  providedIn: 'root'
})
export class LineaTService {

    public httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
        })
    };

API_ENDPOINT: string =  Constants.BASEURLAPI + '/api';
url_documentos = this.API_ENDPOINT + '/listarDocumentos';

  constructor(private httpClient: HttpClient) { }

public mostrarConducta() {
    return this.httpClient.get(this.API_ENDPOINT + '/mostrarConducta', this.httpOptions);
    }

    
public mostrarTipoVinculacion() {
    return this.httpClient.get(this.API_ENDPOINT + '/mostrarTipoVinculacion', this.httpOptions);
    }
public mostrarDept() {
        return this.httpClient.get(this.API_ENDPOINT + '/mostrarDept', this.httpOptions);
    }
public mostrarMunp(deptid) {
     return this.httpClient.get(this.API_ENDPOINT + '/mostrarMunp?deptid=' + deptid , this.httpOptions);
    }
 
public insertDenuncias(formData : FormData, denuncia : any){
        console.log('que pedo wy**', formData, 'Content-Type',  'application/json');
        return this.httpClient.post<any>(this.API_ENDPOINT+'/upload5/',formData, {reportProgress : true,
            observe : 'events'});
       }   


       uploadFile(formData) {
 
        let urlApi = this.API_ENDPOINT + '/subir';
        return this.httpClient.post<any>(urlApi, {params :formData});
     }


}


    
